import * as z from "zod";
import { minMessage, requiredFieldMessage } from "@/schemas/messages";
import { requiredEnumWithNumberValueSchema } from "@/schemas/common";
import type { CampaignRead } from "@/types/api/types.ts";

export const campaignSchema = z.custom<CampaignRead>().refine((val) => !!val, {
  message: requiredFieldMessage,
});

export const schema = z.object({
  code: z.string().min(1, minMessage(1)).max(255, minMessage(255)),
  name: z.string().min(1, minMessage(1)).max(255, minMessage(255)),
  description: z.string().nullable(),
  startDate: z.coerce.date(),
  endDate: z.coerce.date(),
  status: requiredEnumWithNumberValueSchema,
  statusComment: z.string(),
  anonymous: z.boolean(),
  campaign: campaignSchema,
  flags: z
    .array(
      z.object({
        ["@id"]: z.string(),
        ["@type"]: z.string(),
        name: z.string(),
        uuid: z.string(),
        category: requiredEnumWithNumberValueSchema,
        available: z.boolean(),
      })
    )
    .default([]),
});

export type ModuleFormType = z.infer<typeof schema>;

export const newSchema = schema
  .omit({
    campaign: true,
    statusComment: true,
  })
  .extend({
    campaign: campaignSchema,
  });

export type NewModuleFormType = z.infer<typeof newSchema>;
